import React, { Fragment } from 'react';

function QuestionSlider({ introText = null, onChange, value, name = '', autoFocus = true, minLabel = '', maxLabel = '' }) {
  return (
    <Fragment>
      {/* introText is used on the outro page */}
      {introText && <p>{introText}</p>}
      <div className="slider">
        <div className="slider__half">
          <div className="slider__tiles">
            {[1, 2, 3, 4, 5].map(number => (
              <div key={number} className={parseInt(value, 10) === number ? 'checked' : ''}>
                <label>
                  <input
                    type="radio"
                    name={name}
                    value={number}
                    checked={parseInt(value, 10) === number || false}
                    onChange={onChange}
                    autoFocus={autoFocus && number === 1}
                  />
                  {number}
                </label>
              </div>
            ))}
          </div>
          <div className="slider__label">
            {minLabel}
          </div>
        </div>
        <div className="slider__half">
          <div className="slider__tiles">
            {[6, 7, 8, 9, 10].map(number => (
              <div key={number} className={parseInt(value, 10) === number ? 'checked' : ''}>
                <label>
                  <input
                    type="radio"
                    name={name}
                    value={number}
                    checked={parseInt(value, 10) === number || false}
                    onChange={onChange}
                  />
                  {number}
                </label>
              </div>
            ))}
          </div>
          <div className="slider__label">
            {maxLabel}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default QuestionSlider;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionSlider.js